import { render, staticRenderFns } from "./BaseFooter.vue?vue&type=template&id=75a3b61c&scoped=true&"
import script from "./BaseFooter.vue?vue&type=script&lang=js&"
export * from "./BaseFooter.vue?vue&type=script&lang=js&"
import style0 from "./BaseFooter.vue?vue&type=style&index=0&id=75a3b61c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a3b61c",
  null
  
)

export default component.exports